import request from "@/utils/request";
// 登录
export function merchantUserinfoApi() {
  return request({
    url: "merchant/userInfo",
    method: "get",
  });
}
// 获取商品列表
export function getmerchantListApi(data) {
  return request({
    url: "merchant/product/index",
    method: "get",
    params: data,
  });
}
// 删除商品
export function delProductApi(data) {
  return request({
    url: "merchant/product/delete/" + data.id,
    method: "delete",
  });
}
// 上架下架
export function ipDownproductApi(data) {
  return request({
    url: "merchant/product/updateIsShow/" + data.id,
    method: "put",
  });
}
// 创建商品
export function productCreateApi(data) {
  return request({
    url: "merchant/product/create",
    method: "get",
    params: data,
  });
}
// 运费模板列表
export function getTemplateApi() {
  return request({
    url: "merchant/shipping/template/list",
    method: "get",
  });
}
// 运费模板列表
export function productSaveApi(data) {
  return request({
    url: "merchant/product/save",
    method: "post",
    data,
  });
}
// 获取运费城市
export function templatereadApi(data) {
  return request({
    url: "merchant/shipping/template/read",
    method: "get",
    params: data,
  });
}

// 保存运费模板
export function SaveTemplateApi(data) {
  return request({
    url: "merchant/shipping/template/save",
    method: "post",
    data,
  });
}
// 导出待处理订单
export function exportOrderDoApi(data) {
  return request({
    url: "merchant/order/exportOrderDo",
    method: "post",
    data,
  });
}
// 导出待处理订单2
export function exportOrderDetailDoApi(data) {
  return request({
    url: "merchant/order/exportOrderDetailDo",
    method: "post",
    data,
  });
}


// 删除运费模板
export function DelTemplateApi(data) {
  return request({
    url: "merchant/shipping/template/delete",
    method: "delete",
    data,
  });
}
// 待处理信息
export function exportOrderApi(data) {
  return request({
    url: "merchant/order/exportOrderWeb",
    method: "get",
    params: data,
  });
}
// 发货信息
export function getOrderApi(data) {
  return request({
    url: "merchant/order/list",
    method: "get",
    params: data,
  });
}

//获取对方在本店订单详情
export function merListApi(data) {
  return request({
    url: "user/order/merList",
    method: "get",
    params: data,
  });
}
//查询物流详情
export function deliveryDetailApi(data) {
  return request({
    url: "user/order/kuaidiDetail",
    method: "get",
    params: data,
  });
}
//查询物流详情
export function uploadDeliveryInfoApi(data) {
  return request({
    url: "merchant/order/delivery",
    method: "post",
    data,
  });
}
//获取快递公司
export function getexpressListApi(data) {
  return request({
    url: "express/list",
    method: "get",
    params: data,
  });
}
//获取订单
export function userOrdersListApi(data) {
  return request({
    url: "user/order/list",
    method: "get",
    params: data,
  });
}
//上传快递单号
export function uploadDeliveryApi(data) {
  return request({
    url: "merchant/order/delivery",
    method: "post",
    data,
  });
}
// 圈子收益列表
export function getgroupProfitApi(data) {
  return request({
    url: "chatgroup/group/profitLists",
    method: "get",
    params: data,
  });
}
// 会议收益列表
export function getmeetProfitApi(data) {
  return request({
    url: "manage/meet/profitLists",
    method: "get",
    params: data,
  });
}
//批量上传快递单号
export function AlluploadDeliveryApi(data) {
  return request({
    url: "merchant/order/importExcel",
    method: "post",
    data
  });
}
// 小店通知数量
export function getmerchantIndexApi(data) {
  return request({
    url: "merchant/index",
    method: "get",
    params: data,
  });
}
// 认证状态
export function getAuthenticationApi(data) {
  return request({
    url: "user/getAuthentication/list",
    method: "get",
    params: data,
  });
}
export function realnameStatusApi(data) {
  return request({
    url: "user/real_name/status",
    method: "get",
    params: data,
  });
}
export function BusinessInfoApi(data) {
  return request({
    url: "manage/business/info",
    method: "get",
    params: data,
  });
}
// 企业认证状态
export function businessApplyApi(data) {
  return request({
    url: "business/apply",
    method: "post",
    data
  });
}
// 提交企业认证
export function businessApplyDoApi(data) {
  return request({
    url: "business/apply_do",
    method: "post",
    data
  });
}
// 查询入驻状态
export function merchantStatusApi(data) {
  return request({
    url: "merchant/status",
    method: "get",
    params: data,
  });
}
// 提交小店申请
export function merchantCreateApi(data) {
  return request({
    url: "merchant/create",
    method: "post",
    data
  });
}
// 小店申请前
export function merchantBeforeCreateApi(data) {
  return request({
    url: "merchant/beforeCreate",
    method: "get",
    params: data,
  });
}
// 银行卡信息
export function bankListApi(data) {
  return request({
    url: "user/bank/list",
    method: "get",
    params: data,
  });
}
// 删除银行卡
export function delbankApi(data) {
  return request({
    url: "user/bank/delete/" + data.id,
    method: "delete",
  });
}
// 添加银行卡前获取数据
export function bankCreateApi(data) {
  return request({
    url: "user/bank/create",
    method: "get",
    params: data,
  });
}
// 保存银行卡 
export function bankSaveApi(data) {
  return request({
    url: "user/bank/save",
    method: "post",
    data
  });
}
// 添加收益与数据
export function merchantHelperApi(data) {
  return request({
    url: "merchant/helper/index",
    method: "get",
    params: data,
  });
}
// 添加所有商品
export function merchantProductApi(data) {
  return request({
    url: "merchant/product/index",
    method: "get",
    params: data,
  });
}
// 近30天收益分析
export function merchantAssignProfitApi(data) {
  return request({
    url: "merchant/helper/assignProfit",
    method: "get",
    params: data,
  });
}
// 下单前三榜
export function rangeListOfGoodApi(data) {
  return request({
    url: "merchant/helper/rangeListOfGood",
    method: "get",
    params: data,
  });
}
// 差评前三榜
export function rangeListOfBadApi(data) {
  return request({
    url: "merchant/helper/rangeListOfBad",
    method: "get",
    params: data,
  });
}
// 售后详情
export function saleAfterDetailApi(data) {
  return request({
    url: "merchant/saleAfterDetail",
    method: "get",
    params: data,
  });
}
// 商品详情
export function orderShopDetailApi(data) {
  return request({
    url: "user/order/shopDetail",
    method: "get",
    params: data,
  });
}
// 退款 
export function orderRefundApi(data) {
  return request({
    url: "shop/order/orderRefund",
    method: "post",
    data
  });
}
// 退款申请
export function merchantReplyApi(data) {
  return request({
    url: "merchant/reply",
    method: "post",
    data
  });
}
// 订单备注
export function addOrderCommentApi(data) {
  return request({
    url: "merchant/order/addOrderComment",
    method: "post",
    data
  });
}
// 订单数量
export function getOrderNumApi(data) {
  return request({
    url: "merchant/order/orderCount",
    method: "get",
    params: data,
  });
}
// 订单列表
export function getlistWebApi(data) {
  return request({
    url: "merchant/order/listWeb",
    method: "get",
    params: data,
  });
}
// 售后
export function afterSaleListApi(data) {
  return request({
    url: "merchant/order/afterSaleList",
    method: "get",
    params: data,
  });
}

// 售后数量
export function afterOrderCountApi(data) {
  return request({
    url: "merchant/order/afterOrderCount",
    method: "get",
    params: data,
  });
}
// 商家取消订单
export function merchantCancelApi(data) {
  return request({
    url: "user/order/merchantCancel ",
    method: "post",
    data
  });
}
// 商品数量
export function specCountApi(data) {
  return request({
    url: "merchant/product/specCount",
    method: "get",
    params: data,
  });
}
// 售罄商品
export function remindStockApi(data) {
  return request({
    url: "merchant/product/remindStock",
    method: "get",
    params: data,
  });
}
// 获取评价
export function getEvaluateApi(data) {
  return request({
    url: "appraise/appraiseList",
    method: "get",
    params: data,
  });
}
// 评价操作
export function operateEvaluateApi(data) {
  return request({
    url: "appraise/operate",
    method: "post",
    params: data,
  });
}
// 回复评价
export function replayEvaluateApi(data) {
  return request({
    url: "appraise/replay",
    method: "post",
    params: data,
  });
}
// 评价数目
export function appraiseNumApi(data) {
  return request({
    url: "appraise/appraiseNum",
    method: "get",
    params: data,
  });
}
// 获取邮箱
export function getContentListApi(data) {
  return request({
    url: "merchant/order/contentList",
    method: "get",
    params: data,
  });
}
// 添加邮箱
export function addContentListApi(data) {
  return request({
    url: "merchant/order/addContent",
    method: "post",
    params: data,
  });
}
// 删除邮箱
export function delContentListApi(data) {
  return request({
    url: "merchant/order/delContent",
    method: "post",
    params: data,
  });
}

// 获取商品来源
export function getsourceListApi(data) {
  return request({
    url: "merchant/product/sourceList",
    method: "get",
    params: data,
  });
}
// 获取星推管id
export function distributeGetStoresApi(data) {
  return request({
    url: "distribute/getStores",
    method: "get",
    params: data,
  });
}
// 添加来源
export function addSourceListApi(data) {
  return request({
    url: "merchant/product/addSource",
    method: "post",
    params: data,
  });
}
export function editSourceApi(data) {
  return request({
    url: "merchant/product/editSource",
    method: "post",
    data,
  });
}
// 删除来源
export function delSourceApi(data) {
  return request({
    url: "merchant/product/delSource",
    method: "post",
    params: data,
  });
}

// 待处理切换
export function exportOrderDetailWebApi(data) {
  return request({
    url: "merchant/order/exportOrderDetailWeb",
    method: "get",
    params: data,
  });
}
// 打单
export function printOrderThirdApi(data) {
  return request({
    url: "merchant/order/printOrderThird",
    method: "post",
    data,
  });
}


